import type { FieldNumberProps } from "./field-number.type";

import { Form, InputNumber } from "antd";

export const FieldNumber = ({
  name,
  label,
  required,
  disabled,
  hidden,
  min,
  max,
  placeholder,
  className,
}: FieldNumberProps) => {
  return (
    <Form.Item
      name={name}
      label={label}
      rules={required ? [{ required: true }] : undefined}
      required={required}
      hidden={hidden}
      className={className}
    >
      <InputNumber
        placeholder={placeholder}
        disabled={disabled}
        min={min}
        max={max}
      />
    </Form.Item>
  );
};
